import { render, staticRenderFns } from "./ShareCustomerDialog.vue?vue&type=template&id=7bebb252&scoped=true"
import script from "./ShareCustomerDialog.vue?vue&type=script&lang=js"
export * from "./ShareCustomerDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomerDialog.vue?vue&type=style&index=0&id=7bebb252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bebb252",
  null
  
)

export default component.exports